module.exports = __webpack_public_path__ + "08b1253f693870ea4e66a571d2bf3461.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/user/notes/edit/edit-note.html
// module id = 2498
// module chunks = 0